import { markRaw } from 'vue'
import widgetFilterType from '@/constants/widgetFilterType'
import FilterSelect
    from '@/components/next-gen/widget-pages/shared/filters/FilterSelect.vue'
import FilterEnabled
    from '@/components/next-gen/widget-pages/shared/filters/FilterEnabled.vue'
import FilterFlatSelect
    from '@/components/next-gen/widget-pages/shared/filters/FilterFlatSelect.vue'

export default Object.freeze({
    [widgetFilterType.enabled]: markRaw(FilterEnabled),
    [widgetFilterType.select]: markRaw(FilterSelect),
    [widgetFilterType.flatSelect]: markRaw(FilterFlatSelect),
})
